import React from "react";

const MentionMeReferee = () => {
  return <div id="mmWrapper"></div>;
};

export default MentionMeReferee;